import { axios, baseURL } from '@axios'
import encryptionService from '@/services/encryption.service'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchQuotations(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/clerical/quotations', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQuotationMetas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/clerical/quotations/metas', { params: queryParams })
          .then(response => (resolve(response)))
          .catch(error => reject(error))
      })
    },
    fetchQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/clerical/quotations/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/clerical/quotations', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/clerical/quotations/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    duplicateQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/v1/clerical/quotations/${id}/duplicate`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        fetch(`${baseURL}/api/v1/clerical/quotations/${id}.pdf`, {
          method: 'GET',
          headers: {
            ...JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders'))),
            'Content-Type': 'application/octet-stream',
          },
        })
          .then(response => resolve(response.blob()))
          .catch(error => reject(error))
      })
    },
    printReport(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams()
        urlParams.append('search_text', params.search_text)
        urlParams.append('start_date', params.start_date)
        urlParams.append('end_date', params.end_date)

        fetch(`${baseURL}/api/v1/clerical/quotations.csv?${urlParams}`, {
          method: 'GET',
          headers: JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders'))),
        })
          .then(response => resolve(response.blob()))
          .catch(error => reject(error))
      })
    },
    remindQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/v1/clerical/quotations/${id}/reminder`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/clerical/quotations/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchActivities(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/clerical/quotations/${params.id}/activity`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
